<div
    class="relative inset-0 flex w-full flex-col overflow-hidden"
    *transloco="let t"
>
    <!-- Header -->
    <div
        class="bg-card flex flex-0 flex-col border-b p-6 sm:flex-row sm:items-center sm:justify-between sm:px-2 sm:py-4 dark:bg-transparent"
    >
        <div class="min-w-0 flex-1">
            <au-title>
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="mr-2 icon-size-8"
                >
                    mode_fan
                </mat-icon>
                {{ t('digitai.Engine') }} ({{ t('digitai.Model') }}
                {{
                    currentViewAction.meta.fleet.engineModelName ||
                        currentViewAction.meta.fleet?.engineModel?.name
                }})
            </au-title>
        </div>

        <!-- Actions -->
        <div class="mt-6 flex flex-shrink-0 items-center sm:ml-4 sm:mt-0">
            @if (
                currentViewAction.id ===
                'digitai::fleetAircraftEngine.detailDialog.edit'
            ) {
                <button
                    mat-flat-button
                    type="submit"
                    class="ml-3"
                    form="digitaiFleetAircraftEngineFormDetail"
                    color="accent"
                    [disabled]="
                        fg.pristine ||
                        ('digitai::fleetAircraftEngine.detail.update'
                            | getActionStatus
                            | async)
                    "
                >
                    @if (
                        'digitai::fleetAircraftEngine.detail.update'
                            | getActionStatus
                            | async
                    ) {
                        <mat-icon>
                            <mat-spinner diameter="20"></mat-spinner>
                        </mat-icon>
                    } @else {
                        <mat-icon
                            svgIcon="mat_solid:edit"
                            class="mr-2 icon-size-5"
                        >
                        </mat-icon>
                    }
                    {{ t('Update') }}
                </button>
            }

            @if (
                currentViewAction.id ===
                    'digitai::fleetAircraftEngine.detailDialog.new' ||
                currentViewAction.id ===
                    'digitai::fleetAircraftEngine.detailDialog.pool'
            ) {
                <button
                    mat-flat-button
                    type="submit"
                    form="digitaiFleetAircraftEngineFormDetail"
                    class="ml-3"
                    color="accent"
                    [disabled]="
                        fg.pristine ||
                        ('digitai::fleetAircraftEngine.detail.create'
                            | getActionStatus
                            | async)
                    "
                >
                    @if (
                        'digitai::fleetAircraftEngine.detail.create'
                            | getActionStatus
                            | async
                    ) {
                        <mat-icon>
                            <mat-spinner diameter="20"></mat-spinner>
                        </mat-icon>
                    } @else {
                        <mat-icon
                            svgIcon="mat_solid:save"
                            class="mr-2 icon-size-5"
                        >
                        </mat-icon>
                    }
                    {{ t('Create') }}
                </button>
            }

            @if (
                currentViewAction.id ===
                'digitai::fleetAircraftEngine.detailDialog.link'
            ) {
                <button
                    mat-flat-button
                    type="submit"
                    form="digitaiFleetAircraftEngineFormDetail"
                    class="ml-3"
                    color="accent"
                    [disabled]="
                        fg.pristine ||
                        ('digitai::fleetAircraftEngine.detail.update'
                            | getActionStatus
                            | async)
                    "
                >
                    @if (
                        'digitai::fleetAircraftEngine.detail.update'
                            | getActionStatus
                            | async
                    ) {
                        <mat-icon>
                            <mat-spinner diameter="20"></mat-spinner>
                        </mat-icon>
                    } @else {
                        <mat-icon class="mr-2 icon-size-5">
                            attach_file
                        </mat-icon>
                    }
                    {{ t('digitai.LinkEngine') }}
                </button>
            }

            <button
                mat-icon-button
                class="ml-2"
                [disableRipple]="true"
                [mat-dialog-close]="undefined"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <!-- / Actions -->
    </div>
    <!-- / Header -->

    <!-- Main -->
    <div
        class="flex-auto overflow-y-auto px-2 pt-6"
        cdkScrollable
    >
        <div class="form-card px-1 pt-1">
            <form
                id="digitaiFleetAircraftEngineFormDetail"
                novalidate
                [formGroup]="fg"
                (ngSubmit)="onSubmit($event)"
            >
                <div class="layout__container">
                    @if (
                        currentViewAction.id !==
                        'digitai::fleetAircraftEngine.detailDialog.pool'
                    ) {
                        <mat-form-field
                            appearance="outline"
                            class="col-3"
                        >
                            <mat-label>{{ t('digitai.Position') }}</mat-label>
                            <mat-select formControlName="position" required>
                                @for (nMotor of totalMotors; track nMotor) {
                                    <mat-option
                                        [value]="nMotor"
                                        [disabled]="
                                            fleetAircraftAssembledPositionMotors().has(
                                                nMotor
                                            )
                                        "
                                    >
                                        {{ nMotor }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-error>{{
                                formErrors?.position | async
                            }}</mat-error>
                        </mat-form-field>
                    }

                    <mat-form-field
                        appearance="outline"
                        [class]="
                            currentViewAction.id ===
                            'digitai::fleetAircraftEngine.detailDialog.pool'
                                ? 'col-12'
                                : 'col-9'
                        "
                    >
                        <mat-label>{{ t('digitai.SerialNumber') }}</mat-label>
                        <input
                            matInput
                            formControlName="serialNumber"
                            maxlength="128"
                            required
                        />
                        <mat-error>{{
                            formErrors?.serialNumber | async
                        }}</mat-error>
                    </mat-form-field>

                    @if (
                        currentViewAction.id !==
                        'digitai::fleetAircraftEngine.detailDialog.pool'
                    ) {
                        <!-- flying hours -->
                        <mat-form-field
                            appearance="outline"
                            class="col-3"
                        >
                            <mat-label>{{
                                t('digitai.EngineFlyingHours')
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="engineFlyingHours"
                                type="number"
                                min="0"
                            />
                            <mat-error>{{
                                formErrors?.engineFlyingHours | async
                            }}</mat-error>
                        </mat-form-field>
                    }
                    @if (
                        currentViewAction.id !==
                        'digitai::fleetAircraftEngine.detailDialog.pool'
                    ) {
                        <mat-form-field
                            appearance="outline"
                            class="col-3"
                        >
                            <mat-label>{{
                                t('digitai.EngineOperationDate')
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="operationDate"
                                required
                                [auDatetimepickerSqlFormat]
                                [mtxDatetimepicker]="operationDatePicker"
                            />
                            <mtx-datetimepicker-toggle
                                [for]="operationDatePicker"
                                matSuffix
                            >
                            </mtx-datetimepicker-toggle>
                            <mtx-datetimepicker
                                #operationDatePicker
                                type="datetime"
                                mode="landscape"
                                [multiYearSelector]="false"
                                startView="month"
                                [twelvehour]="false"
                                [timeInterval]="1"
                                [touchUi]="false"
                            >
                            </mtx-datetimepicker>
                            <mat-error>{{
                                formErrors?.operationDate | async
                            }}</mat-error>
                        </mat-form-field>
                    }
                </div>
            </form>
        </div>
    </div>
    <!-- / Main -->
</div>
